import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import LoadingModal from 'modals/LoadingModal';

export const FlagListingModalContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "FlagListingModalContainer" */
      './FlagListingModalContainer.dynamic'
    ),
  loading: LoadingModal,
});
